/* eslint-disable */
require("./access-point");
require("./archive-outline");
require("./file-download-outline");
require("./cellphone-play");
require("./email-arrow-right-outline");
require("./email-sync-outline");
require("./folder-marker-outline");
require("./microsoft-windows");
require("./support");
require("./television-play");
require("./list-box-outline");
require("./billing");
require("./account-cog-outline");
